import { registerComponent as rcV1 } from "pf-payment-calculator/dist/client";
import { registerComponent as rcV2 } from "pf-payment-calculator-v2/dist/client";
import dynamicRegistry from "dynamic-module-registry";
import {
  staticConstants as constants,
  getDynamicConstants,
} from "../../constants-ui";
import disclosuresOld, {
  paymentCalculatorDisclosuresV2 as disclosuresNew,
} from "../../disclosures";
import utils from "../../shared_modules/utils";
import drm from "dynamic-module-registry";

const calcModel = dynamicRegistry.get("calcModel");
const { shouldShowUpdatedAdsTerms } = calcModel.adsTerms;

const disclosures = shouldShowUpdatedAdsTerms ? disclosuresNew : disclosuresOld;
const registerComponent = shouldShowUpdatedAdsTerms ? rcV2 : rcV1;

const getDisclosureContent = () => {
  return [
    {
      type: "lc_il",
      title: constants.LC_PLANS.displayName,
      content: disclosures.LC_PLANS,
    },
    {
      type: "ni",
      title: constants.PAYMENT_DETAILS_PROMOTIONAL_NO_INTEREST.displayName,
      content: disclosures.PAYMENT_DETAILS_PROMOTIONAL_NO_INTEREST,
    },
    {
      type: "ni",
      title: constants.INTEREST_FREE_LOAN.pluralName,
      content: disclosures.NO_INTEREST_PLAN,
    },
    {
      type: "prp",
      title: constants.PAYMENT_DETAILS_PROMOTIONAL_PLANS.displayName,
      content: disclosures.PAYMENT_DETAILS_PROMOTIONAL_PLANS,
    },
    {
      type: "prp",
      title: constants.PROMOTIONAL_RATE_PLAN.pluralName,
      content: disclosures.PROMOTIONAL_RATE_PLAN,
    },
    {
      type: "prp",
      title: constants.ALL_PROMOTIONAL_PLANS.displayName,
      content: disclosures.ALL_PROMOTIONAL_PLANS,
      displayAsterisk: true,
    },
  ];
};

const isPatientFlow = function (window) {
  return /\/patients\?|\/patients$/.test(window.location.href);
};

const isMobile = function () {
  return /Mobi/i.test(window.navigator.userAgent);
};

const convertParamsToObj = (params) =>
  params.split("&").reduce((obj, value) => {
    const [, key, val] = /(.*)=(.*)/g.exec(value);
    obj[key] = val;
    return obj;
  }, {});

const setFocusToFieldWithinFrame = (selector) => {
  const iframes = Array.prototype.slice.call(
    window.parent.document.getElementsByClassName("calcFrame"),
  );
  iframes.forEach((frame) => {
    frame.onload = function () {
      const [amountField] = document.getElementsByClassName(selector);
      amountField.focus();
    };
  });
};
const setCloseWindowClick = (onClose) => {
  const closeWindowButtons = Array.prototype.slice.call(
    document.getElementsByClassName("close-window"),
  );
  if (closeWindowButtons && closeWindowButtons.length) {
    closeWindowButtons.forEach((button) => {
      button.onclick = onClose;
    });
  }
};

window.onload = async function () {
  let navigation = {};
  let onPrint;
  let onClose;
  let onClick;
  const chatFive9Context = drm.get("chatFive9Context");

  const goBack = (e) => {
    window.location = "/patientsolutions";
  };
  const applyNow = () => {
    const searchParams = new URLSearchParams(window.location.search);
    let redirectUrl = "/patientsolutions/app/search";
    if (searchParams.get("clientId")) {
      redirectUrl = `/patientsolutions/app/check-your-rate?clientid=${searchParams.get(
        "clientId",
      )}`;
    }
    window.location.assign(redirectUrl);
  };

  let amountFieldSelector = "amount";

  const reactRoot = document.querySelector(".react-calculator-root");
  const printMode = /print/.test(window.location.search);
  const additonalParams = window.location.search
    ? "&" + window.location.search.substring(1)
    : "";

  // Checks for the existance of being contained within as Iframe
  // TODO: Remove the need for the iframe!!!
  const closeActiveModal = () => {
    const modals = Array.prototype.slice.call(
      window.parent.document.getElementsByClassName("lc-modal"),
    );
    modals.forEach((modal) => {
      if (modal.className.indexOf("close") === -1) {
        modal.click();
      }
    });
  };

  if (window.parent) {
    const text = isPatientFlow(window.parent) ? "Apply Now" : "Enroll Now";

    onClose = () => {
      closeActiveModal();
    };

    onClick = applyNow;

    onPrint = (e, options) => {
      closeActiveModal();
      const { amount, brand, clientId } = options;
      let queryStr = `?print=true&amount=${amount}`;

      if (queryStr.indexOf("&brand") === -1 && brand) {
        queryStr += `&brand=${brand}`;
      }

      if (["group", "corporation"].includes(calcModel.orgType)) {
        // Use clientId for selected practice
        queryStr = `${queryStr}&clientId=${clientId}&type=practice`;
      } else {
        queryStr = `${queryStr}${additonalParams ? additonalParams : ""}`;
      }

      window.open(`/patientsolutions/app/payment-calculator${queryStr}`);
    };

    navigation = { text, onClick };
    if (isPatientFlow(window.parent)) {
      navigation.className = "payment-calculator__button--apply-now";
    }
  }

  if (reactRoot) {
    const mobileMode = isMobile();

    const additionalParams = window.location.search
      ? convertParamsToObj(window.location.search.substring(1))
      : {};
    // Deprecated brand qs now we use specialty
    delete additionalParams.brand;

    let dynamicConstants;
    try {
      dynamicConstants = await getDynamicConstants();
    } catch (e) {
      dynamicConstants = constants;
    }

    registerComponent(reactRoot, {
      fetchProductsUrl:
        "/patientsolutions/app/payment-calculator/products/list",
      fetchPlansUrl: "/patientsolutions/app/payment-calculator/plans",
      ...calcModel,
      onClick: resizeIframe,
      navigation,
      onPrint,
      printMode,
      mobileMode,
      onClose: !calcModel.class && onClose,
      goBack,
      applyNow,
      additionalParams,
      constants: dynamicConstants,
      disclosureContent: getDisclosureContent(),
    });
    if (printMode) {
      setTimeout(() => window.print(), 300);
    }
    amountFieldSelector = "form__amount";
  }
  utils.renderFive9Chat(chatFive9Context);
  setFocusToFieldWithinFrame(amountFieldSelector);
  setCloseWindowClick(onClose);

  const loaders =
    window.parent.document.getElementsByClassName("transition-loader");
  if (loaders && loaders.length) {
    Array.prototype.forEach.call(loaders, function (loader) {
      loader.style.display = "none";
    });
  }
};

const iFrame = window.parent.document.querySelector("iframe");
function resizeIframe() {
  const calculatorElement = document.querySelector(".calculator-body");
  if (!iFrame && calculatorElement.scrollHeight < 1) return;
  iFrame.height = `${calculatorElement.scrollHeight + 8}px`;
}

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/calculator/calculator.scss');